import { Routes, Route, Outlet } from 'react-router-dom';

import FleetManagerPage from './components/FleetManagerPage';
import VolumePage from './components/VolumePage/VolumePage';
import DatafySwitchProvider from './components/DatafySwitchProvider';

function FleetManagerLayout() {
  return (
    <DatafySwitchProvider>
      <Outlet />
    </DatafySwitchProvider>
  );
}

export default function FleetManagerRoutes() {
  return (
    <Routes>
      <Route path="/*" element={<FleetManagerLayout />}>
        <Route index element={<FleetManagerPage />} />
        <Route path=":id" element={<VolumePage />} />
      </Route>
    </Routes>
  );
}
